"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var entities_1 = require("./entities");
var defaultLocale = "en";
var TimeRange;
(function (TimeRange) {
    TimeRange["OneHour"] = "OneHour";
    TimeRange["TwoHours"] = "TwoHours";
    TimeRange["ThreeHours"] = "ThreeHours";
    TimeRange["SixHours"] = "SixHours";
    TimeRange["TwelveHours"] = "TwelveHours";
    TimeRange["OneDay"] = "OneDay";
    TimeRange["TwoDays"] = "TwoDays";
    TimeRange["ThreeDays"] = "ThreeDays";
    TimeRange["SevenDays"] = "SevenDays";
})(TimeRange = exports.TimeRange || (exports.TimeRange = {}));
var Query = /** @class */ (function () {
    function Query() {
    }
    // format?: QueryFormat
    // from?: From
    // readonly includeMarkets?: string
    // readonly timeRange?: TimeRangeEnum
    Query.composeQueryString = function (query) {
        var includeMarketsParam = query.params["includeMarkets"] ? "&includeMarkets=" + encodeURIComponent("" + query.params["includeMarkets"]) : "";
        var fromParam = DurationFilter.getFromStartDateParam(query.params["from"]);
        var timeRangeParam = query.params["timeRange"] ? "&timeRange=" + query.params["timeRange"] : "";
        var initialData = query.params["initialData"] ? "&initialData=" + query.params["initialData"] : "";
        var queryUrl = "?query=" + encodeURIComponent(query.query) + includeMarketsParam + fromParam + timeRangeParam + initialData;
        return queryUrl;
    };
    Query.setDefaults = function (query) {
        if (!query)
            throw Error("query can't be null");
        if (!query.params["format"])
            query.params["format"] = "ODataV3";
        if (!query.params["from"])
            //query.params["from"] = {kind: "Now"}
            if (!query.locale)
                query.locale = defaultLocale;
    };
    Query.validate = function (query) {
        if (!query)
            throw Error("query can't be null");
        if (!query.params["format"])
            throw Error("query format can't be null");
        Query.parseEntityType(query);
    };
    Query.parseEntityType = function (query) {
        var entity = query.params["format"] === 'ODataV3'
            ? query.query.split('?')[0].toLowerCase()
            : null;
        switch (entity) {
            case 'events': return entities_1.entities.EntityType.Event;
            case 'markets': return entities_1.entities.EntityType.Market;
            case 'sports': return entities_1.entities.EntityType.Sport;
            case 'regions': return entities_1.entities.EntityType.Region;
            case 'leagues': return entities_1.entities.EntityType.League;
            default: throw Error('query has invalid entity type.');
        }
    };
    /**
     * Creates query to get Games
     */
    Query.getGames = function (args) {
        var query = "Events?";
        var filters = [];
        args = args || {};
        if (typeof args.isLive !== 'undefined')
            filters.push("(isLive eq " + args.isLive + ")");
        if (args.sportId)
            filters.push("(sportId eq " + args.sportId + ")");
        if (args.leagueId)
            filters.push("(leagueId eq " + args.leagueId + ")");
        if (filters.length > 0) {
            query += "$filter=" + filters.join(' and ');
        }
        return query;
    };
    /**
     * Creates query to get Leagues
     */
    Query.getLeagues = function (args) {
        var query = "Leagues?$filter=(sportId eq " + args.sportId + ")";
        if (args.regionId)
            query += " and (regionId eq " + args.regionId + ")";
        if (args.isHot)
            query += " and (isHot eq " + args.isHot + ")";
        return query;
    };
    /**
     * Creates query to get Sports
     */
    Query.getSports = function () {
        return "Sports";
    };
    return Query;
}());
exports.Query = Query;
var DurationFilter = /** @class */ (function () {
    function DurationFilter() {
    }
    DurationFilter.getFromStartDateParam = function (fromStartDate) {
        if (fromStartDate && fromStartDate.kind === "Date") {
            return "&from=" + fromStartDate.value.toISOString();
        }
        return '';
    };
    return DurationFilter;
}());
//# sourceMappingURL=query.js.map